import React from 'react';
import { useProductSections } from '@/features/constructorProducts/hooks';
import { SectionList } from '@/features/constructorCommon';

export const ProductSectionList = ({productId = ''}) => {
  const {data, isLoading} = useProductSections(productId);

  return (
    <SectionList data={data} isLoading={isLoading} type={'products'}/>
  );
};
